import { render, staticRenderFns } from "./CreateSGDbOps.vue?vue&type=template&id=384edd0c&scoped=true"
import script from "./CreateSGDbOps.vue?vue&type=script&lang=js"
export * from "./CreateSGDbOps.vue?vue&type=script&lang=js"
import style0 from "./CreateSGDbOps.vue?vue&type=style&index=0&id=384edd0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384edd0c",
  null
  
)

export default component.exports